module.exports = __webpack_public_path__ + "img/1491-1492.31e9d2a1.jpg";